export const FETCH_SITE_INFO = 'FETCH_SITE_INFO';
export const FETCH_SITE_INFO_SUCCESS = 'FETCH_SITE_INFO_SUCCESS';
export const FETCH_SITE_INFO_FAILURE = 'FETCH_SITE_INFO_FAILURE';

export const fetchSiteInfo = () => ({
  type: FETCH_SITE_INFO,
});

export const fetchSiteInfoSuccess = (payload) => ({
  type: FETCH_SITE_INFO_SUCCESS,
  payload,
});

export const fetchSiteInfoFailure = () => ({
  type: FETCH_SITE_INFO_FAILURE,
});

const INIT_STATE = {
  zendeskFAQLink: '',
  offerings: [],
  multipleOfferingMode: false,
  campaignLinks: {
    regularClass: [],
    course: [],
    activity: [],
  },
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SITE_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;

export const getZendeskFAQLink = (state) => state.siteInfo.zendeskFAQLink;
export const getOfferingList = (state) => state.siteInfo.offerings;
export const getMultipleOfferingMode = (state) =>
  state.siteInfo.multipleOfferingMode;
export const getCampaignLinks = (state) => state.siteInfo.campaignLinks;



// WEBPACK FOOTER //
// ./src/services/redux/siteInfo.js